import { Injectable } from '@angular/core';
import { InfoDialogComponent } from './info-dialog/info-dialog.component';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';

@Injectable()
export class InfoDialogService {
	private opened = false;

	constructor(private readonly dialogService: NxDialogService) {}

	openDialog(businessError: any): void {
		if (!this.opened) {
			this.opened = true;
			var componentDialogRef: NxModalRef<InfoDialogComponent> = 
				this.dialogService.open( InfoDialogComponent,{ariaLabel: '', showCloseIcon: true, data: businessError},);

			componentDialogRef.afterClosed().subscribe(() => {
				this.opened = false;
			});
		}
	}
}
